<style>
    h1 {
        text-transform: capitalize;
    }
</style>
<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Buat Pembayaran Pembelian</h1>
          </div>
         <div class="section-body">
            <!-- <h2 class="section-title">Harga Total :$. {{ currencyFormat(transaksiDetail.detail.total_harga) }}</h2>
            <p class="section-lead">Dibayar : $. {{ currencyFormat(transaksiDetail.detail.dibayar) }} </p> -->
            <div class="row">
                <div class="col-12  col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Detail Pembayaran</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Pilih Faktur</label>
                                <multiselect v-if="jenis_pembayaran == 'invoice'" @close="getProdukList()" v-model="transaksiSelected" :options="transaksiOptions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pilih Transaksi Yang Ingin Dibayar" label="inv_name" track-by="srt_value" :preselect-first="true">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} transaksi dipilih</span></template>
                                </multiselect>
                                <multiselect v-else @close="getProdukList()" v-model="transaksiSelected" :options="transaksiOptions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pilih Transaksi Yang Ingin Dibayar" label="srt_name" track-by="srt_value" :preselect-first="true">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} transaksi dipilih</span></template>
                                </multiselect>
                            </div>
                            <table v-if="transaksiSelected.length > 0" class="table-hover">
                                <tr>
                                    <th>Nama Supplier : &nbsp; </th>
                                    <td> {{ transaksiSelected[0].nama_kontak }} </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Invoice</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Nomor Invoice</label>
                                <input type="text" class="form-control" v-model="nomor_invoice" placeholder="Masukkan Nomor Invoice">
                            </div>
                            <div class="form-group">
                                <label>Tanggal Invoice</label>
                                <vc-date-picker v-model="tanggal_invoice" :input-props='{class: "form-control",placeholder: "Masukkan tanggal transaksi",}'/>
                            </div>
                            <div class="form-group">
                                <label>Tanggal Jatuh Tempo Pembayaran</label>
                                <vc-date-picker v-model="tanggal_tempo" :input-props='{class: "form-control",placeholder: "Masukkan tanggal jatuh tempo"}'/>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Produk</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <tr>
                                        <td> 
                                            <div class="form-group">
                                                <div class="selectgroup w-100">
                                                    <label class="selectgroup-item">
                                                        <input type="radio" value="0" v-model="wilayah_pembelian" class="selectgroup-input">
                                                        <span class="selectgroup-button">IMPORT</span>
                                                    </label>
                                                    <label class="selectgroup-item">
                                                        <input type="radio" value="1" v-model="wilayah_pembelian" class="selectgroup-input">
                                                        <span class="selectgroup-button">DN</span>
                                                    </label>
                                                </div>
                                            </div> 
                                        </td>
                                        <th v-if="wilayah_pembelian == '0'" colspan="2" style="vertical-align:top">Kurs USD to IDR sekarang</th>
                                        <td v-if="wilayah_pembelian == '0'">
                                            <div class="form-group">
                                                <input type="text" @change="countKurs()" class="form-control" v-model="kurs_usd"> 
                                            </div>
                                        </td> 
                                    </tr>
                                    <tr>
                                        <th>Produk</th>
                                        <th>Nomor Transaksi</th>
                                        <th>Kuantitas</th>
                                        <th>Satuan</th>
                                        <th>Harga Satuan ($)</th>
                                        <th>Harga Satuan (IDR)</th>
                                        <th>Jumlah ($)</th>
                                        <th>Jumlah (IDR)</th>
                                    </tr>
                                    <tbody v-if="bodyRender">
                                        <tr v-for="(data,index) in produkList" v-bind:key="index">
                                            <td>
                                            {{ data.transaksi_nama_produk }} 
                                            </td>
                                            <td>
                                                {{ data.nomor_transaksi }}
                                            </td>
                                            <td>
                                                {{ data.qty_send }}
                                            </td>
                                            <td>
                                                {{ data.nama_satuan }}
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" :disabled="disableUsd" @change="countHarga(index)" class="form-control" v-model="data.harga_satuan"> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" :disabled="disableIdr" @change="countHargaUsd(index)" class="form-control" v-model="data.harga_satuan_idr"> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" :disabled="disableUsd" class="form-control" @change="countSatuan(index)" v-model="data.harga_total"> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input type="text" :disabled="disableIdr" class="form-control" @change="countIdr(index)" v-model="data.harga_total_idr"> 
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="text-align:right" colspan="6">Sub Total Tagihan</th>
                                            <th>USD {{ currencyFormat(sub_total_tagihan) }}</th>
                                            <th>IDR {{ currencyFormat(sub_total_tagihan_idr) }} </th>
                                        </tr>
                                        <tr v-for="(bl,inde) in biaya_lain">
                                            <th style="text-align:right;" colspan="6">
                                                {{ bl.nama_biaya }}
                                            </th>
                                            <th>
                                                {{ bl.jumlah_biaya }} {{ biayaIconCallback(bl.jenis_biaya) }}
                                            </th>
                                            <th>
                                                <button class="btn btn-danger" @click="hapusBiaya(inde)">Hapus</button>
                                            </th>
                                        </tr>
                                        <tr v-for="tx in tax">
                                            <!-- <th style="text-align:right" colspan="4"><input type="checkbox" id="jack" v-model="tx.status"> Bayar dengan akun lain</th>
                                            <th>
                                                <div v-show="tx.status" class="form-group">
                                                    <select id="akun_bayar" v-model="tx.akun_bayar_tax" class="form-control select2">
                                                        <option value="">Pilih Akun Pembayaran</option>
                                                        <option v-for="(option, ind) in akunBayarList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </th> -->
                                            <th colspan="6">
                                                <input placeholder="Nama Biaya" style="width:15%;float:right" type="text" class="form-control" v-model="tx.nama_biaya">
                                            </th>
                                            <td>
                                                <div class="input-group">
                                                    <input placeholder="Jumlah Biaya" type="text" v-model="tx.jumlah_biaya" class="form-control phone-number">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            {{ biayaIconCallback(tx.jenis_biaya) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <select class="form-control" placeholder="Pilih Jenis Biaya" v-model="tx.jenis_biaya">
                                                    <option value="percentage">Persen</option>
                                                    <option value="idr">IDR</option>
                                                    <option value="usd">USD</option>
                                                </select>
                                            
                                            </td>
                                            
                                        </tr>
                                        <tr>
                                            <td style="text-align:right;" v-if="tax.length > 0" colspan="6">
                                                <button @click="submitBiayaLain()" class="btn btn-success">Submit Biaya</button>
                                            </td>
                                            <td colspan="7" v-if="tax.length < 1" style="text-align:right;">
                                                <button @click="addBiayaLain()" class="btn btn-primary">+ Tambah Biaya Lain</button>
                                            </td>
                                            <td v-else style="text-align:right;">
                                                <button @click="addBiayaLain()" class="btn btn-primary">+ Tambah Biaya Lain</button>
                                            </td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <th style="text-align:right" colspan="6">Total Tagihan</th>
                                            <th>USD {{ currencyFormat(total_tagihan) }}</th>
                                            <th>IDR {{ currencyFormat(total_tagihan_idr) }} </th>
                                        </tr>
                                        <tr>
                                            <th colspan="6" style="text-align:right">Telah Dibayar</th>
                                            <th>
                                                USD {{ currencyFormat(dibayar) }} 
                                            </th>
                                            <th>
                                                IDR {{ currencyFormat(dibayar_idr) }} 
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="6" style="text-align:right">Akan Dibayar</th>
                                            <td>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <i class="fa fa-dollar"></i>
                                                        </div>
                                                    </div>
                                                    <input :disabled="disableUsd" type="text" @input="getDibayarIdr()" v-model="akan_dibayar" class="form-control"> 
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            Rp.
                                                        </div>
                                                    </div>
                                                    <input :disabled="disableIdr" type="text" @input="getDibayarUsd()" v-model="akan_dibayar_idr" class="form-control"> 
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="akan_dibayar > 0 || akan_dibayar_idr > 0">
                                            <th colspan="6" style="text-align:right">Bayar Dari</th>
                                            <td colspan="2" style="text-align:center;vertical-align:middle;">
                                                <select id="akun_bayar" v-model="akun_bayar" class="form-control select2">
                                                        <option disabled value="">--Pilih Akun Bayar--</option>
                                                        <option v-for="option in akunBayarList" v-bind:key="option.id_coa" :value="option.id_coa">({{option.kode_akun}}) - {{ option.nama_akun}} ({{option.deskripsi}})</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr v-if="akan_dibayar > 0 || akan_dibayar_idr > 0">
                                            <th colspan="6" style="text-align:right">Tanggal Pembayaran</th>
                                            <td colspan="2" style="text-align:center;vertical-align:middle;">
                                                <vc-date-picker v-model="tanggal_pembayaran" :input-props='{class: "form-control",placeholder: "Masukkan tanggal pembayaran",style:"text-align:center;vertical-align:middle"}'/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="text-align:right" colspan="6">Sisa Tagihan</th>
                                            <th>USD {{ currencyFormat(total_semua) }}</th>
                                            <th>IDR {{ currencyFormat(total_semua_idr) }} </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="submitPembayaran()" class="btn btn-primary"> <i class="fa fa-dollar"></i> Update Pembayaran</button>
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
td {
    height: 30px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Vue from 'vue'
import VCalendar from 'v-calendar';
import Multiselect from 'vue-multiselect'

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

var future = new Date();
future.setDate(future.getDate() + 30);

export default {
    data() {
        return {
            nomor_invoice : '',
            produkList : [],
            transaksiSelected : [],
            tanggal_tempo: future,
            tanggal_invoice: new Date,
            transaksiList: [],
            transaksiOptions: [],
            jenis_pembayaran: '',
            url : '',
            wilayah_pembelian : '',
            jenis_transaksi : 'pembelian',
            produkDiterima : [],
            kurs_usd : 0,
            bodyRender : true,
            pajak : 0,
            tax : [],
            biaya_lain : [],
            dibayar: 0,
            dibayar_idr : 0,
            akan_dibayar: 0,
            akan_dibayar_idr : 0,
            done : false,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            disableIdr : true,
            disableUsd : true,
            tipe : (this.$route.params.tipe_transaksi == 'pemesanan' || this.$route.params.tipe_transaksi == 'packing') ? 'transaksi' : 'progress',
            tanggal_pembayaran : '',
            akunList: [],
            akunBayarList: [],
            akun_bayar: '',
        }
    },
    mounted() {
        if(this.$parent.isprice == false) {
            this.goBack();
            this.$parent.toastr = {
                title : 'Error',
                message : 'Not authorized to access this page',
                type : 'error'
            }
        }
        this.jenis_pembayaran = this.$route.params.jenis_pembayaran;
        this.init();
    },
    methods: {
        init: function() {
            //get faktur
            this.$root.is_loading = true
            this.$http.get("Transaksi/getPembelianListFaktur/"+this.jenis_pembayaran).then(result => {
			    if(result.data.code == '00') {
                    alert('Gagal mengambil transaksi / Tidak ada transaksi untuk dibayar')
                }
                else {
                    this.transaksiList = result.data.detail;
                    let that = this
                    this.transaksiList.forEach(function(item,index){
                        that.transaksiList[index].nomor_transaksi = item.nomor_transaksi + ' | ' + item.display_name
                        that.transaksiList[index].nomor_pengiriman = item.nomor_pengiriman + ' | ' + item.display_name
                        that.transaksiOptions.push({ inv_name : item.nomor_transaksi , srt_name : item.nomor_pengiriman , inv_value : item.id_transaksi , srt_value : item.id_transaksi_progress, id_kontak : item.id_kontak, nama_kontak : item.display_name })
                    })
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });

            // get coa/akun list
			this.$http.post("Datalist/getCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get coa')
                }
                else {
                    this.akunList = result.data.detail;
                    this.akunBayarList = this.filterArr(this.akunList,'id_kategori','3');
                    // this.akunJualList = this.filterArr(this.akunList,'id_kategori','13')
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        goBack: function() {
            this.$router.go(-1)
        },
        submitPembayaran: function() {

            if(this.akan_dibayar > 0 && this.akun_bayar == '')
            {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tolong pilih akun bayar !',
                    type : 'warning'
                }
                return false
            }

            if(this.nomor_invoice == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Nomor Invoice Tidak Boleh Kosong !',
                    type : 'warning'
                }
                return false
            }

            if(this.tanggal_invoice == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tanggal Invoice Tidak Boleh Kosong !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan jumlah pembayaran sudah sesuai !')){
                return false
            }

            var tanggal_pembayaran = '';
            if(this.tanggal_pembayaran != '' && this.tanggal_pembayaran != null)
            {
                tanggal_pembayaran = this.formatDate(this.tanggal_pembayaran);
            }

            var formsub = new FormData()
            var objThis = this

            formsub.append('akun_bayar',this.akun_bayar);
            formsub.append('akan_dibayar',this.akan_dibayar);
            formsub.append('akan_dibayar_idr',this.akan_dibayar_idr);
            formsub.append('kurs_usd',this.kurs_usd);
            formsub.append('wilayah_pembayaran',this.wilayah_pembelian);
            formsub.append('total_harga',this.total_tagihan);
            formsub.append('total_harga_idr',this.total_tagihan_idr);
            formsub.append('outstanding',(this.total_semua));
            formsub.append('outstanding_idr',(this.total_semua_idr));
            formsub.append('subtotal', this.sub_total_tagihan);
            formsub.append('subtotal_idr', this.sub_total_tagihan_idr);
            formsub.append('jenis_pembayaran',this.jenis_pembayaran);
            formsub.append('jenis_transaksi',this.jenis_transaksi);
            formsub.append('tanggal_invoice', this.formatDate(this.tanggal_invoice));
            formsub.append('tanggal_tempo', this.formatDate(this.tanggal_tempo));
            formsub.append('tanggal_pembayaran', tanggal_pembayaran);
            formsub.append('nomor_invoice', this.nomor_invoice);
            formsub.append('id_kontak', this.transaksiSelected[0].id_kontak);
            var islunas = (this.total_semua_idr <= 0 && this.total_semua <= 0) ? 1 : 0;
            formsub.append('is_lunas',islunas);
            
            $.map(objThis.biaya_lain, function(value,index){
                    formsub.append('biayaLain['+index+'][nama_biaya]', value.nama_biaya);
                    formsub.append('biayaLain['+index+'][jumlah_biaya]', value.jumlah_biaya);
                    formsub.append('biayaLain['+index+'][jenis_biaya]', value.jenis_biaya);
                    formsub.append('biayaLain['+index+'][akun_bayar_tax]', value.akun_bayar_tax);
            });

            $.map(objThis.produkList, function(value,index){
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][id_transaksi_produk]', value.id_transaksi_produk);
                    formsub.append('dataProduk['+index+'][id_transaksi_progress]', value.id_transaksi_progress);
                    formsub.append('dataProduk['+index+'][harga_satuan]', value.harga_satuan);
                    formsub.append('dataProduk['+index+'][harga_total]', value.harga_total);
                    formsub.append('dataProduk['+index+'][harga_satuan_idr]', value.harga_satuan_idr);
                    formsub.append('dataProduk['+index+'][harga_total_idr]', value.harga_total_idr);
            });

            $.map(objThis.transaksiSelected, function(value,index){
                    formsub.append('transaksiSelected['+index+'][inv_value]', value.inv_value);
                    formsub.append('transaksiSelected['+index+'][srt_value]', value.srt_value);
            });

            this.$http.post("Transaksi/insertMakePayment", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.$router.go(-1)
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal silahkan hubungi operator !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
            
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        countHarga: function(index) {
            if(this.produkList[index].harga_satuan == 0){
                this.produkList[index].harga_satuan = (this.produkList[index].harga_total / this.produkList[index].qty_send).toFixed(2);
            }else{
                this.produkList[index].harga_total = (this.produkList[index].harga_satuan * this.produkList[index].qty_send).toFixed(2);
                this.produkList[index].harga_satuan_idr = (this.produkList[index].harga_satuan * this.kurs_usd).toFixed(2);
                this.produkList[index].harga_total_idr = (this.produkList[index].harga_satuan_idr * this.produkList[index].qty_send).toFixed(2);
            }
        },
        countHargaUsd: function(index) {
            if(this.produkList[index].harga_satuan_idr == 0){
                this.produkList[index].harga_satuan_idr = (this.produkList[index].harga_total_idr / this.produkList[index].qty_send).toFixed(2);
            }else{
                if(this.disableUsd == false){
                    this.produkList[index].harga_satuan = (this.produkList[index].harga_satuan_idr / this.kurs_usd).toFixed(2);
                    this.produkList[index].harga_total = (this.produkList[index].harga_satuan * this.produkList[index].qty_send).toFixed(2);
                }else {
                    this.produkList[index].harga_satuan = 0;
                    this.produkList[index].harga_total = 0;
                }
                this.produkList[index].harga_total_idr = (this.produkList[index].harga_satuan_idr * this.produkList[index].qty_send).toFixed(2);
            }
        },
        countSatuan: function(index) {
            this.produkList[index].harga_satuan = (this.produkList[index].harga_total / this.produkList[index].qty_send).toFixed(2);
            this.produkList[index].harga_satuan_idr = (this.produkList[index].harga_satuan * this.kurs_usd).toFixed(2);
            this.produkList[index].harga_total_idr = (this.produkList[index].harga_satuan_idr * this.produkList[index].qty_send).toFixed(2)
        },
        countKurs: function() {
            let that = this
            this.produkList.forEach(function(item,index){
                that.produkList[index].harga_satuan_idr = (item.harga_satuan * that.kurs_usd).toFixed(2);
                that.produkList[index].harga_total_idr =  (item.harga_total * that.kurs_usd).toFixed(2);
            })
            this.getDibayarIdr();
            this.bodyRender = false
            this.$nextTick(function(){
                this.bodyRender = true
            })
        },
        countIdr: function(index) {
            this.produkList[index].harga_satuan_idr = (this.produkList[index].harga_total_idr / this.produkList[index].qty_send).toFixed(2)
            if(this.disableUsd == false){
                this.produkList[index].harga_satuan = (this.produkList[index].harga_satuan_idr / this.kurs_usd).toFixed(2)
                this.produkList[index].harga_total = (this.produkList[index].harga_satuan * this.produkList[index].qty_send).toFixed(2)
            }
        },
        getDibayarIdr: function() {
            this.akan_dibayar_idr = (this.akan_dibayar * this.kurs_usd).toFixed(2)
        },
        getDibayarUsd: function() {
            if(this.disableUsd){
                this.akan_dibayar = 0
            }else{
                this.akan_dibayar = (this.akan_dibayar_idr/this.kurs_usd).toFixed(2);
            }
        },
        getProdukList: function() {
            if(this.transaksiSelected.length > 0){
                var first = this.transaksiSelected[0].id_kontak
                var jml = this.transaksiSelected.length
                var count = 0
                let that = this
                this.transaksiSelected.forEach(function(item,index){
                    if(first != item.id_kontak){
                        that.$parent.toastr = {
                            title : 'Error',
                            message: 'Transaksi Harus Dari 1 Supplier yang sama',
                            type : 'error'
                        }
                        that.produkList = [];
                        return false
                    }else {
                        count++
                        if(count == jml){
                            that.getProdukAfterVerification();
                        }
                    }
                })     
            }       
        },
        getProdukAfterVerification: function() {
            var formsub = new FormData()
            var objThis = this
            formsub.append('jenis_permbayaran', this.jenis_pembayaran)
            $.map(objThis.transaksiSelected, function(value,index){
                    formsub.append('dataTransaksi['+index+'][id_transaksi]', value.inv_value);
                    formsub.append('dataTransaksi['+index+'][id_transaksi_progress]', value.srt_value);
            });

            this.$http.post("Transaksi/getProdukListPembayaran/"+this.jenis_pembayaran, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Berhasil mendapatkan data produk !',
                        type : 'success'
                    }
                    this.produkList = result.data.detail
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Tidak ada produk / gagal mengambil produk !',
                        type : 'error'
                    }         
                    this.produkList = []           
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
        },
        addBiayaLain: function() {
            if(this.tax.length > 0){
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Tolong Submit biaya yang sedang diinput !',
                    type : 'error'
                }
                return false
            }
            var ct = this.biaya_lain.length
            this.tax.push({
                id_tax : ct,
                nama_biaya : '',
                jumlah_biaya : '',
                jenis_biaya : 'percentage',
                status : false,
                akun_bayar_tax : '',
                submited : false,
            })
        },
        submitBiayaLain: function() {
            if(this.tax[0].nama_biaya == '') {
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Nama Biaya Harus Diisi !',
                    type : 'error'
                }
                return false
            }else if(this.tax[0].jumlah_biaya == '') {
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Jumlah Biaya Harus Diisi !',
                    type : 'error'
                }
                return false
            }

            if(this.disableUsd) {
                if(this.tax[0].jenis_biaya == 'usd'){
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Kamu tidak bisa menggunakan USD dalam transaksi dalam negeri',
                        type : 'error'
                    }
                    return false
                }
            }

            this.biaya_lain.push(this.tax[0])

            this.tax = []
            this.$parent.toastr = {
                title : 'Success',
                message: 'Berhasil menambah biaya lain !',
                type : 'success'
            }
        },
        biayaIconCallback: function(jenis) {
            if(jenis == 'percentage') {
                return '%'
            }else if(jenis == 'idr') {
                return 'IDR'
            }else if(jenis == 'usd') {
                return 'USD'
            }
        },
        hapusBiaya: function(index) {
            this.$parent.toastr = {
                title : 'Success',
                message: 'Biaya '+this.biaya_lain[index].nama_biaya+' berhasil dihapus !',
                type : 'success'
            }
            this.$nextTick(function(){
                this.biaya_lain.splice(index, 1);
            })
        },
        filterArr: function(array,prop,value) {
            var filtered = [];
            for(var i = 0; i < array.length; i++){
                if(array[i][prop] == value){
                    filtered.push(array[i])
                }
            }    
            return filtered;
        },
    },
    components: {
        Multiselect
    },
    watch: {
        'kurs_usd' : function() {
            if(this.transaksiSelected.length <= 0){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tolong pilih faktur terlebih dahulu !',
                    type : 'error'
                }
                return false
            }
            if(this.kurs_usd <= 0 && this.wilayah_pembelian == '0'){
                this.disableIdr = true
            }else if(this.kurs_usd > 0 && this.wilayah_pembelian == '0'){
                this.disableIdr = false
            }
        },
        'wilayah_pembelian': function() {
            if(this.transaksiSelected.length <= 0){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tolong pilih faktur terlebih dahulu !',
                    type : 'error'
                }
                return false
            }
            this.kurs_usd = 0
            let that = this
            this.produkList.forEach(function(item,index){
                that.produkList[index].harga_satuan_idr = 0;
                that.produkList[index].harga_satuan =  0;
                that.produkList[index].harga_total = 0;
                that.produkList[index].harga_total_idr = 0;
            })
            if(this.wilayah_pembelian == '0'){
                this.disableUsd = false
                this.disableIdr = true
            }else if(this.wilayah_pembelian == '1'){
                this.disableUsd = true
                this.disableIdr = false
            }
        }
    },
    computed: {
        total_semua : function() {
            var totals = 0;
            if(this.disableUsd){
                return totals
            }else {
                let that = this
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total) + totals
                })
                var bayar = this.akan_dibayar
                if(bayar == ''){
                    bayar = 0
                }
                var totalPajak = totals
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = it.jumlah_biaya/that.kurs_usd
                        }else if(it.jenis_biaya == 'usd') {
                            valuebiaya = it.jumlah_biaya
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return (totalPajak - parseFloat(bayar)).toFixed(2)
            }
        },
        total_semua_idr : function() {
            // if(this.disableUsd){
                var totals = 0;
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total_idr) + totals
                })
                var bayar = this.akan_dibayar_idr
                if(bayar == ''){
                    bayar = 0
                }
                var totalPajak = totals
                let that = this
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = parseFloat(it.jumlah_biaya)
                        }else if(it.jenis_biaya == 'usd') {
                            return 'Kamu tidak bisa menggunakan jenis biaya USD pada pembayaran dalam negeri'
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return (totalPajak - parseFloat(bayar)).toFixed(2)
            // }else {
            //     return this.total_semua * this.kurs_usd
            // }
        },
        total_tagihan : function() {
            var totals = 0;
            if(this.disableUsd){
                return totals
            }else {
                let that = this
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(that.produkList[index].harga_total) + totals
                })
                
                var totalPajak = totals
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = it.jumlah_biaya/that.kurs_usd
                        }else if(it.jenis_biaya == 'usd') {
                            valuebiaya = it.jumlah_biaya
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return totalPajak.toFixed(2)
            }
            
        },
        total_tagihan_idr : function() {
            // if(this.disableUsd){
                var totals = 0;
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total_idr) + totals
                })
                console.log(totals)
                var totalPajak = totals
                let that = this
                if(this.biaya_lain.length > 0){
                    this.biaya_lain.forEach(function(it,ind){
                        var valuebiaya = 0
                        if(it.jenis_biaya == 'percentage') {
                            valuebiaya = (it.jumlah_biaya/100) * totals
                        }else if(it.jenis_biaya == 'idr') {
                            valuebiaya = parseFloat(it.jumlah_biaya)
                        }else if(it.jenis_biaya == 'usd') {
                            return 'Kamu tidak bisa menggunakan jenis biaya USD pada pembayaran dalam negeri'
                        }
                        totalPajak = totalPajak + valuebiaya
                    })
                }
                return totalPajak.toFixed(2)
            // }else {
            //     return this.total_tagihan * this.kurs_usd
            // }
        },
        sub_total_tagihan : function() {
            var totals = 0;
            this.produkList.forEach(function(item, index){
                totals = parseFloat(item.harga_total) + totals
            })
            return totals.toFixed(2)
        },
        sub_total_tagihan_idr : function() {
            if(this.disableUsd) {
                var totals = 0;
                this.produkList.forEach(function(item, index){
                    totals = parseFloat(item.harga_total_idr) + totals
                })
                return totals.toFixed(2)
            }else { 
                return this.sub_total_tagihan * this.kurs_usd
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembelian/MakePayment.vue